import React from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Button, Table, Alert, Spinner } from 'react-bootstrap';

//Actions
import { pesquisa as pesquisaperguntas } from '../../../../actions/questionario/questionarios';
import { pesquisa, novoatualizaperguntas } from '../../../../actions/forms/validacao';

//Components
import { camporadio, campotexto } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

class FormPerguntasValidacao extends React.Component {

    async componentDidMount(){

        const evento = getEvento();

        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            idformulario: 38          
        });

        await this.props.pesquisaperguntas({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento            
        });
    }

    handleSubmit = async (dados) => {

        const evento = getEvento();
        
        let result = [];
        let linguagem = '';
        if(dados){
            result = Object.keys(dados).map(campo => {
                if(campo !== 'categoria' && dados[campo] !== false){
                    const str = campo.split("_");
                    linguagem = str[2];
                    return str[1];
                }
            })
        }
        
        const cadupdate = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            categoria: dados.categoria,
            linguagem: linguagem,
            perguntasobrigatorias: result.join("|"),
            idformulario: 38
        }

        await this.props.novoatualizaperguntas(cadupdate);

        await this.props.pesquisa({
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            idformulario: 38         
        });
    }
        
    handleModalCadastro = (form) => {
        form.reset();
    }

    handleInitialValus = (cadastrosvalidacao, linguagem) => {
        let result = {};
        console.log(cadastrosvalidacao);
        if(cadastrosvalidacao){
            const perguntas = cadastrosvalidacao;
            if(perguntas.length){
                perguntas.map(idpergunta => {
                    result = {
                        ...result,
                        [`perg_${idpergunta}_${linguagem}`]: idpergunta
                    }
                    return null;
                })
            }
        }
        return result;
    }
            
    render() {        
        return (
            <> 
            {Object.keys(this.props.categoriaspergs).length&&this.props.categoriaspergs.map(categorias => {
                const perguntas_obrigatorias = categorias.perguntasobrigatorias?categorias.perguntasobrigatorias.split("|"):false;
                console.log(categorias);
                return(     
                    <Form
                    key={categorias.id}
                    onSubmit={this.handleSubmit}
                    initialValues={{...this.handleInitialValus(perguntas_obrigatorias, categorias.linguagem), categoria: categorias.categoria}}
                    render={({ submitting, pristine, form, handleSubmit, submitSucceeded }) => {
                        this.formfinal = form;                
                        const gravou = submitSucceeded&&this.props.cadupdated&&this.props.cadupdated.id?true:false;
                        
                        return (
                            <form onSubmit={handleSubmit} name={`form_${categorias.linguagem}`}>
                                <TelaModalLivre show={gravou} handleCloseModal={() => this.handleModalCadastro(form)}>
                                    <Alert variant="success">Cadastro Feito com Sucesso</Alert>
                                </TelaModalLivre>               
                                <Table striped bordered hover style={{paddingBottom: '15px', marginBottom: '15px'}}>
                                    <thead>
                                        <tr>
                                        <th>Pergunta</th>                                
                                        <th>Categoria</th>
                                        <th>Linguagem</th>
                                        <th>Obrigatória</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.cadastros.length?this.props.cadastros.map(itens => {
                                            return (
                                                <tr key={itens.idpergunta}>
                                                    <td className="text-break">
                                                        {itens.portugues}
                                                    </td>
                                                    <td className="text-break">
                                                        {categorias.baseformcategoria.descricao}
                                                    </td>
                                                    <td className="text-break">
                                                        {categorias.linguagem}
                                                    </td>
                                                    <td className="text-break">
                                                        <Field type="checkbox" name={`perg_${itens.idpergunta}_${categorias.linguagem}`} component={camporadio} />
                                                    </td>
                                                </tr>                                                                             
                                            )                                    
                                            })
                                            :
                                            null
                                        }
                                    </tbody>
                                </Table>
                                <Table striped bordered hover className="table-dark">
                                    <tbody>                                
                                        <tr>
                                            <td className="text-center" colSpan="3">
                                                <Button type="submit" disabled={pristine || submitting}>
                                                    {this.props.pendingTasks?
                                                    <Spinner animation="border"  />
                                                    :
                                                    null
                                                    }
                                                    Confirmar
                                                </Button>
                                            </td>
                                        </tr>                                          
                                    </tbody>
                                </Table>
                            </form>
                        )
                    }}
                    />
                )
            })}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks,
        cadastros: state.pergrespReducer,
        categoriaspergs: state.formsPesquisaCamposReducer,
        cadupdated: state.formsNovoAtualizaCamposReducer,
        cadastrosvalidacao: state.formsPesquisaCamposReducer 
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualizaperguntas, pesquisaperguntas })(FormPerguntasValidacao);